import { Stack, useBreakpointValue } from "@chakra-ui/react";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import BackToTopProvider from "contexts/BackToTopProvider";
import DocumentsPageTabs from "./documentsTabs/documentsTabPanels/DocumentsPageTabs";

const marginTop = mobileStyleBreakpoint("16px", "88px");

const DocumentsPage = () => {
  const docPageMarginTop = useBreakpointValue(marginTop);

  return (
    <Stack style={{ marginTop: docPageMarginTop }}>
      <BackToTopProvider>
        <DocumentsPageTabs />
      </BackToTopProvider>
    </Stack>
  );
};

export default DocumentsPage;
